import React, { Component } from 'react';
import { renderAsync } from 'docx-preview/dist/docx-preview';
import MetaGroup from '../../components/meta-group';

class MasterServicesAgreement extends Component {
    documentHostRef = React.createRef();

    componentDidMount() {
        this.renderDocx();
    }

    renderDocx = () => {
        if (!this.documentHostRef.current) {
            return;
        }

        fetch('/msa-document.docx')
            .then((response) => response.arrayBuffer())
            .then((arrayBuffer) => {
                this.documentHostRef.current.innerHTML = '';

                return renderAsync(arrayBuffer, this.documentHostRef.current, null, {
                    inWrapper: false,
                    breakPages: true,
                    ignoreLastRenderedPageBreak: false,
                    useBase64URL: true
                });
            })
            .then(() => {
                this.normalizeBulletGlyphs();
            })
            .catch(() => {
                if (this.documentHostRef.current) {
                    this.documentHostRef.current.innerHTML = '<p>Unable to load the Master Services Agreement document.</p>';
                }
            });
    };

    normalizeBulletGlyphs = () => {
        if (!this.documentHostRef.current) {
            return;
        }

        // Some Word symbol-font bullets render as hollow squares in browser output.
        // Replace leading marker glyphs with a standard bullet for legibility.
        const blocks = this.documentHostRef.current.querySelectorAll('p, li, div');
        blocks.forEach((block) => {
            const walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT);
            const firstTextNode = walker.nextNode();
            if (!firstTextNode) {
                return;
            }

            firstTextNode.textContent = firstTextNode.textContent.replace(/^(\s*)□(\s+)/, '$1•$2');
        });
    };

    render() {
        return (
            <div>
                <MetaGroup
                    title="Master Services Agreement | Rossware"
                    metaDescription="Master Services Agreement for Rossware Software services."
                    ogImage=""
                    canonical="terms-of-service"
                />
                <section className="light-tone">
                    <div className="container-sm">
                        <style>{`
                            .msa-docx p[class*="docx-num-"]::before {
                                font-size: 1em !important;
                                line-height: 1.4 !important;
                            }

                            .msa-docx [style*="Wingdings"],
                            .msa-docx [style*="Symbol"] {
                                font-family: "Segoe UI Symbol", "Arial Unicode MS", sans-serif !important;
                            }
                        `}</style>
                        <div
                            className="mt-4 msa-docx"
                            ref={this.documentHostRef}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

export default MasterServicesAgreement;
